import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @file Created on Fri Apr 17 2020
 */
import { ValidationLevel } from '@logio/common-be-fe';
/**
 * @author Tomáš Leity
 * @author Miroslav Osif
 */

export var ValidationUtils =
/*#__PURE__*/
function () {
  function ValidationUtils() {
    _classCallCheck(this, ValidationUtils);
  }

  _createClass(ValidationUtils, null, [{
    key: "validateField",

    /**
     * Field validation to process validations in Form when we need to process manual validation based on other parameters.
     *
     * @param value
     * @param formValues
     * @param validators
     */
    value: function validateField(value, formValues, validators) {
      // tslint:disable-next-line:prefer-for-of
      for (var i = 0; i < validators.length; i++) {
        var validator = validators[i];
        var result = validator.validate(value, ValidationLevel.Fast);

        if (!result.valid) {
          return result;
        }
      }

      return undefined;
    }
  }]);

  return ValidationUtils;
}();